<template>
    <div class="container">
        <b-row v-if="!isLoading">
	<b-container>
		<md-table v-model="listLideres" md-card md-fixed-header @md-selected="f_muestra">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>{{labels.title}}</i></b></h1>
		</md-table-toolbar>
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell :md-label="labels.id" class="text-center border">{{item.id_usuario}}</md-table-cell>
			<md-table-cell :md-label="labels.email" class="text-left border">{{item.email}}</md-table-cell>
			<md-table-cell :md-label="labels.nombre" class="text-left border">{{item.name}}</md-table-cell>
		</md-table-row>
		</md-table>
	</b-container>
	<b-container v-if="usuarios">
		<md-table v-model="listLiderUsuarios" md-card md-fixed-header @md-selected="f_muestra_usuario">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>RELACION DE USUARIOS</i></b></h1>
			<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionaUsuarios()">
				<md-icon>add</md-icon>
                        </md-button>
		</md-table-toolbar>
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell :md-label="labels.id" class="text-center border">{{item.id_usuario}}</md-table-cell>
			<md-table-cell :md-label="labels.email" class="text-left border">{{item.email}}</md-table-cell>
			<md-table-cell :md-label="labels.nombre" class="text-left border">{{item.name}}</md-table-cell>
		</md-table-row>
		</md-table>
		<span>
		<md-button  class="md-accent" @click="usuarios=false;selecciona=false"> Cerrar </md-button>
		</span>
		<span v-if="selecciona">
		<br><br>
		<select multiple v-model="usuariosSel" class="form-control">
		<option v-for="usuario in listUsuarios" :value="usuario.id" :key="usuario.id">{{ usuario.name }}-({{usuario.email}})</option>
		</select>
		<md-button  class="md-accent" @click="grabaUsuarios()"> Grabar </md-button>
		<md-button  class="md-accent" @click="selecciona=false"> Cerrar </md-button>
		</span>
		<md-dialog :md-active.sync="usuarioLider">
			<md-dialog-title class="text-center">
				<h3><b><i>Usuarios</i></b></h3>
			</md-dialog-title>
			<md-dialog-content>
				<md-table>
					<md-table-row>
						<md-table-cell>ID</md-table-cell>
						<md-table-cell>{{form.idUsuario}}</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>E-mail</md-table-cell>
						<md-table-cell>{{form.email}}</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Nombre</md-table-cell>
						<md-table-cell>{{form.name}}</md-table-cell>
					</md-table-row>
				</md-table>
				<md-dialog-actions>
					<md-button class="md-accent" @click="elimineUsuario()">Eliminar</md-button>
					<md-button class="md-accent" @click="usuarioLider=false">Cerrar</md-button>
				</md-dialog-actions>
			</md-dialog-content>
		</md-dialog>
	</b-container>
        </b-row>
    </div>
</template>
<script>
import Lider from "@/services/Lideres"

export default {
    name:'Lideres',
    data: () => ({
        isLoading: false,
        usuarios: false,
        usuarioLider: false,
        selecciona: false,
	titulo_lider: '',
	lider: '',
        listLideres : [],
	liderActual : {},
        listLiderUsuarios : [],
        listUsuarios : [],
        usuariosSel : [],
	form : {
		idUsuario: '',
		email:'',
		name:'',
	},
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Lideres",
                    id : "ID",
                    email : "E-MAIL",
                    nombre : "NOMBRE",
                }
            }else{
                return {
                    title : "Leaders",
                    id : "ID",
                    email : "E-MAIL",
                    nombre : "NAME",
                }
            }
        }
    },
    mounted(){
        Lider.leaLideres()
        .then((res) => {
            this.listLideres = res.data.listLideres
        })
        .catch((err) => {
            console.log(err)
        })
    },
    methods:{
	f_titulo() {
		return "Informacion Usuario"
	},
	f_muestra(r_lider) {
		this.liderActual = r_lider
		this.lider=r_lider.id_usuario

		Lider.leaLiderUsuarios(r_lider.id_usuario)
		.then((res) => {
			this.listLiderUsuarios= res.data.listLiderUsuarios
		})
		.catch((err) => {
			console.log(err)
		})
		this.usuarios=true

	},
	f_muestra_usuario(r_usuario) {
		if	(typeof r_usuario == "undefined") {
			return
		}
		this.usuarioLider=true
		this.form.idUsuario=r_usuario.id_usuario
		this.form.email=r_usuario.email
		this.form.name=r_usuario.name
	},
	adicionaUsuarios() {
		
		this.selecciona=false
		Lider.leaUsuarios(this.lider)
		.then((res) => {
			this.listUsuarios= res.data.listUsuarios
			this.selecciona=true

		})
		.catch((err) => {
			console.log(err)
		})
	},
	grabaUsuarios() {
		
		this.selecciona=false
		let formaGraba = {
			'lider': this.lider,
			'usuarios': this.usuariosSel,
			'idUser' : this.$store.state.userId
		}

		Lider.asigneLiderUsuarios(formaGraba)
		.then((res) => {
			if	(res.status == 200){
				this.$toast.success("Informacion Grabada correctamente")
				setTimeout(() => {
					this.selecciona=false
					Lider.leaLiderUsuarios(this.lider)
					.then((res) => {
						this.listLiderUsuarios= res.data.listLiderUsuarios
					})
					.catch((err) => {
						console.log(err)
					})
				},1000)
				Lider.leaLiderUsuarios(this.lider)
				.then((res) => {
					this.listLiderUsuarios= res.data.listLiderUsuarios
				})
				.catch((err) => {
					console.log(err)
				})
			} else {
				this.$toast.error(res.data.message+" al grabar")
				this.selecciona=false
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	elimineUsuario() {
		
		let formaElimina = {
			'lider': this.lider,
			'usuario': this.form.idUsuario,
		}

		Lider.elimineLiderUsuario(formaElimina)
		.then((res) => {
			if	(res.status == 200){
				this.$toast.success("Usuario Eliminado correctamente")
				setTimeout(() => {
					this.usuarioLider=false
					Lider.leaLiderUsuarios(this.lider)
					.then((res) => {
						this.listLiderUsuarios= res.data.listLiderUsuarios
					})
					.catch((err) => {
						console.log(err)
					})
				},1000)
			} else {
				this.$toast.error(res.data.message+" al Eliminar Usuario")
				this.usuarioLider=false
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
    }
}
</script>

<style>

</style>
